import api from './api';

const franchiseService = {
    // Get all franchises with optional filters
    async getFranchises(filters = {}) {
        const params = new URLSearchParams();
        Object.keys(filters).forEach(key => {
            if (filters[key]) {
                params.append(key, filters[key]);
            }
        });
        
        const response = await api.get(`/franchises?${params.toString()}`);
        return response.data;
    },

    // Get a specific franchise by ID
    async getFranchise(id) {
        const response = await api.get(`/franchises/${id}`);
        return response.data;
    },

    // Create a new franchise
    async createFranchise(franchiseData) {
        const response = await api.post('/franchises', franchiseData);
        return response.data;
    },

    // Update an existing franchise
    async updateFranchise(id, franchiseData) {
        const response = await api.put(`/franchises/${id}`, franchiseData);
        return response.data;
    },

    // Delete a franchise
    async deleteFranchise(id) {
        const response = await api.delete(`/franchises/${id}`);
        return response.data;
    },

    // Toggle franchise status
    async toggleFranchiseStatus(id) {
        const response = await api.post(`/franchises/${id}/toggle-status`);
        return response.data;
    },

    // Get franchise statistics
    async getFranchiseStatistics(id) {
        const response = await api.get(`/franchises/${id}/statistics`);
        return response.data;
    },

    // Get location data
    async getCountries() {
        const response = await api.get('/location/countries');
        return response.data;
    },

    async getStates(countryId = null) {
        const params = countryId ? `?country_id=${countryId}` : '';
        const response = await api.get(`/location/states${params}`);
        return response.data;
    },

    async getCities(stateId = null) {
        const params = stateId ? `?state_id=${stateId}` : '';
        const response = await api.get(`/location/cities${params}`);
        return response.data;
    }
};

export default franchiseService; 